import { render, staticRenderFns } from "./CheckoutConfirm.vue?vue&type=template&id=670fe59d&scoped=true&"
import script from "./CheckoutConfirm.vue?vue&type=script&lang=js&"
export * from "./CheckoutConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670fe59d",
  null
  
)

export default component.exports